/**
 * The owner's paper-trading wording (B-028). The same sentence the daily email carries
 * (B-022: backend `newsletter_service.PAPER_TRADING_DISCLOSURE`); one frontend constant so every
 * place that shows it says exactly this. A test pins the two copies together.
 */
export const PAPER_TRADING_DISCLOSURE =
  'This is paper trading for learning purposes only. We are not trading real money.';
